import { Afip } from '../models/interfaces/afip';
import { AfipModel } from '../models/afip.model';

export function toAfipModel(data: Afip): AfipModel {
  let response = new AfipModel();

  response.cuit = data.cuit;
  response.razonSocial = data.razonSocial;
  response.domicilioFiscal = data.domicilioFiscal;
  response.estadoClave = data.estadoClave;
  response.tipoImpuesto = data.tipoImpuesto;
  response.actividad = data.actividad;
  response.tipoPersona = data.tipoPersona;

  return response;
}
